import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { NUMBER_SIZE } from '../../../../../../../constants/size'
import { getQaSelector } from '../../../../../../../utils/common'
import { FileImagePreviewError, FilePreviewImage } from '../../../../../../File'
import { FloatingTooltip } from '../../../../../../Floating'
import Text from '../../../../../../Text'
import { getPhotoName } from '../../../../../RentalPortalPhotoGallery'
import {
  getListingMosaicPhotoAlt,
  getListingMosaicPhotoSrc,
} from '../RentalPortalListingPhotoMosaic.utils'

import * as styles from './RentalPortalListingPhotoMosaicTile.module.css'

function RentalPortalListingPhotoMosaicTile({
  className,
  isLead,
  moreCount,
  photo,
  qaName,
  tooltip,
  onClick,
}) {
  const { t } = useTranslation()

  function handleClick() {
    onClick(photo)
  }

  return (
    <FloatingTooltip content={tooltip}>
      <div
        {...getQaSelector({ value: qaName })}
        className={classNames(
          styles.RentalPortalListingPhotoMosaicTile,
          className
        )}
        onClick={handleClick}
      >
        <FilePreviewImage
          ErrorImagePreview={FileImagePreviewError}
          alt={getListingMosaicPhotoAlt(photo, t)}
          errorPreviewImageProps={{
            className: styles.broken,
            size: isLead ? NUMBER_SIZE.size44 : NUMBER_SIZE.size32,
          }}
          filename={getPhotoName(photo)}
          src={getListingMosaicPhotoSrc({ isLead, photo })}
        />
        {moreCount ? (
          <Text className={styles.moreOverlay}>
            {t('RentalPortal.ListingProfilePhotosMoreKey', {
              count: moreCount,
            })}
          </Text>
        ) : null}
      </div>
    </FloatingTooltip>
  )
}

export default RentalPortalListingPhotoMosaicTile
